import React from "react";
import { ToggleButtonsProps } from "./interface";
import "./ToggleButtons.scss"

const Index = ({ value, onStatusChange, firstButtonName, secondButtonName }: ToggleButtonsProps) => {
  return (
    <div className="toggle-buttons">
      <div className={`toggle-option ${value ? "selected" : "unselected"}`}>
        <label htmlFor="status-1" className="toggle-label form-check-label" onClick={() => onStatusChange(true)}>
          <input
            className="toggle-input form-check-input"
            type="radio"
            name="toggle-group"
            id="status-1"
            value={value.toString()}
            checked={value}
          />
          {firstButtonName || "Contact Lens"}
        </label>
      </div>
      <div className={`toggle-option ${!value ? "selected" : "unselected"}`}>
        <label htmlFor="status-2" className="toggle-label" onClick={() => onStatusChange(false)}>
          <input
            className="toggle-input form-check-input form-check-label"
            type="radio"
            name="toggle-group"
            id="status-2"
            value={(!value).toString()}
            checked={!value}
          />
          {secondButtonName || "Other Products"}
        </label>
      </div>
    </div>
  );
};

export default Index;
